import SolicitudesPendientes from "../components/SolicitudesPendientes";
import DetallesCita from "../components/DetallesCita";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMagnifyingGlass,
  faPenToSquare,
} from "@fortawesome/free-solid-svg-icons";
import EditarCita from "../components/EditarCita";

const PaginaDetallesCita = () => {
  return (
    <div className="detalles-cita-container">
      <h1>
        <FontAwesomeIcon
          icon={faMagnifyingGlass}
          style={{ marginRight: "8px", color: "#d32f2f" }}
        />{" "}
        Datos reservación
      </h1>
      <DetallesCita />
      <SolicitudesPendientes />
      <h1>
        <FontAwesomeIcon
          icon={faPenToSquare}
          style={{ marginRight: "8px", color: "#d32f2f" }}
        />
        Editar cita
      </h1>
      <EditarCita />
    </div>
  );
};

export default PaginaDetallesCita;
